export var PartnerOrganizationBillingModel;
(function (PartnerOrganizationBillingModel) {
    PartnerOrganizationBillingModel["VAR"] = "var";
    PartnerOrganizationBillingModel["MSP"] = "msp";
    PartnerOrganizationBillingModel["MSP_CENTRAL"] = "msp_central";
    PartnerOrganizationBillingModel["MSP_ENTERPRISE"] = "msp_enterprise";
})(PartnerOrganizationBillingModel || (PartnerOrganizationBillingModel = {}));
export var PartnerOrganizationBillingModelFamily;
(function (PartnerOrganizationBillingModelFamily) {
    PartnerOrganizationBillingModelFamily["MSP"] = "MSP";
    PartnerOrganizationBillingModelFamily["VAR"] = "VAR";
})(PartnerOrganizationBillingModelFamily || (PartnerOrganizationBillingModelFamily = {}));
export var PartnerOrganizationType;
(function (PartnerOrganizationType) {
    PartnerOrganizationType["ROOT"] = "root";
    PartnerOrganizationType["RESELLER"] = "reseller";
    PartnerOrganizationType["REGULAR"] = "regular";
})(PartnerOrganizationType || (PartnerOrganizationType = {}));
export var PartnerOrganizationStatus;
(function (PartnerOrganizationStatus) {
    PartnerOrganizationStatus["NEW"] = "new";
    PartnerOrganizationStatus["TRIAL"] = "trial";
    PartnerOrganizationStatus["ACTIVE"] = "active";
    PartnerOrganizationStatus["TRIAL_EXPIRED"] = "trial_expired";
    PartnerOrganizationStatus["PAST_DUE"] = "past_due";
    PartnerOrganizationStatus["UNPAID"] = "unpaid";
    PartnerOrganizationStatus["CANCELED"] = "canceled";
    PartnerOrganizationStatus["INCOMPLETE"] = "incomplete";
    PartnerOrganizationStatus["INCOMPLETE_EXPIRED"] = "incomplete_expired";
    PartnerOrganizationStatus["CONTRACT_EXPIRED"] = "contract_expired";
})(PartnerOrganizationStatus || (PartnerOrganizationStatus = {}));
export var PartnerOrganizationTier;
(function (PartnerOrganizationTier) {
    PartnerOrganizationTier["GOLD"] = "gold";
    PartnerOrganizationTier["SILVER"] = "silver";
    PartnerOrganizationTier["AUTHORIZED"] = "authorized";
})(PartnerOrganizationTier || (PartnerOrganizationTier = {}));
export var PartnerOrganizationActionReason;
(function (PartnerOrganizationActionReason) {
    PartnerOrganizationActionReason["NOT_ROOT_MEMBER"] = "notRootMember";
    PartnerOrganizationActionReason["NOT_PARENT_MEMBER"] = "notParentMember";
    PartnerOrganizationActionReason["NOT_ANCESTOR_MEMBER"] = "notAncestorMember";
    PartnerOrganizationActionReason["NOT_CURRENT_OR_ROOT_MEMBER"] = "notCurrentOrRootMember";
    PartnerOrganizationActionReason["NOT_CURRENT_MEMBER"] = "notCurrentMember";
    PartnerOrganizationActionReason["MISSING_UPSERT_CONTRACT_PERMISSION"] = "missingUpsertContractPermission";
    PartnerOrganizationActionReason["INVALID_STATUS"] = "invalidStatus";
    PartnerOrganizationActionReason["HAS_WORKSPACES"] = "hasWorkspaces";
    PartnerOrganizationActionReason["HAS_BILLING"] = "hasBilling";
    PartnerOrganizationActionReason["NO_BILLING"] = "noBilling";
    PartnerOrganizationActionReason["HAS_MIGRATION_CONFIG"] = "hasMigrationConfig";
    PartnerOrganizationActionReason["NO_MIGRATION_CONFIG"] = "noMigrationConfig";
    PartnerOrganizationActionReason["MIGRATION_NOT_COMPLETED"] = "migrationNotCompleted";
    PartnerOrganizationActionReason["NO_PARENT_MIGRATION_CONFIG"] = "noParentMigrationConfig";
    PartnerOrganizationActionReason["PARENT_BILLING_NOT_MIGRATED"] = "parentBillingNotMigrated";
    PartnerOrganizationActionReason["NO_ROOT_BILLING_UNIT"] = "noRootBillingUnit";
    PartnerOrganizationActionReason["TRIAL_EXTENSIONS_EXHAUSTED"] = "trialExtensionsExhausted";
    PartnerOrganizationActionReason["CLASSIC_MIGRATION_NOT_SUPPORTED"] = "classicMigrationNotSupported";
    PartnerOrganizationActionReason["NOT_ENTERPRISE_RESELLER"] = "notEnterpriseReseller";
    PartnerOrganizationActionReason["NO_OWNER"] = "noOwner";
    PartnerOrganizationActionReason["DEMO_FLAG_LOCKED"] = "demoFlagLocked";
    PartnerOrganizationActionReason["CHILD_ORGANIZATION_NOT_DELETABLE"] = "childOrganizationNotDeletable";
})(PartnerOrganizationActionReason || (PartnerOrganizationActionReason = {}));
export var PartnerOrganizationMemberRole;
(function (PartnerOrganizationMemberRole) {
    PartnerOrganizationMemberRole["OWNER"] = "owner";
    PartnerOrganizationMemberRole["COLLABORATOR"] = "collaborator";
    /** Root organization only: set by the `partner-organizations seed` command from the RevOps configuration. */
    PartnerOrganizationMemberRole["REVOPS"] = "revops";
})(PartnerOrganizationMemberRole || (PartnerOrganizationMemberRole = {}));
/** Roles that can be stored on a member, i.e. assigned through the API. */
export const AssignablePartnerOrganizationMemberRole = {
    OWNER: PartnerOrganizationMemberRole.OWNER,
    COLLABORATOR: PartnerOrganizationMemberRole.COLLABORATOR,
};
export var PartnerOrganizationMemberPermission;
(function (PartnerOrganizationMemberPermission) {
    PartnerOrganizationMemberPermission["UPSERT_CONTRACT"] = "upsertContract";
})(PartnerOrganizationMemberPermission || (PartnerOrganizationMemberPermission = {}));
export var PartnerOrganizationMemberStatus;
(function (PartnerOrganizationMemberStatus) {
    PartnerOrganizationMemberStatus["NEW"] = "new";
    PartnerOrganizationMemberStatus["ACTIVE"] = "active";
})(PartnerOrganizationMemberStatus || (PartnerOrganizationMemberStatus = {}));
export var PartnerOrganizationApiKeyPermission;
(function (PartnerOrganizationApiKeyPermission) {
    /** @deprecated Legacy name of {@link ORGANIZATIONS_READ}; still accepted so existing API keys keep working. */
    PartnerOrganizationApiKeyPermission["CLIENTS_READ"] = "clients:read";
    /** @deprecated Legacy name of {@link ORGANIZATIONS_WRITE}; still accepted so existing API keys keep working. */
    PartnerOrganizationApiKeyPermission["CLIENTS_WRITE"] = "clients:write";
    PartnerOrganizationApiKeyPermission["ORGANIZATIONS_READ"] = "organizations:read";
    PartnerOrganizationApiKeyPermission["ORGANIZATIONS_WRITE"] = "organizations:write";
    PartnerOrganizationApiKeyPermission["WORKSPACES_READ"] = "workspaces:read";
    PartnerOrganizationApiKeyPermission["FILESPACES_READ"] = "filespaces:read";
    PartnerOrganizationApiKeyPermission["ME_READ"] = "me:read";
    PartnerOrganizationApiKeyPermission["MEMBERS_READ"] = "members:read";
    PartnerOrganizationApiKeyPermission["MEMBERS_WRITE"] = "members:write";
})(PartnerOrganizationApiKeyPermission || (PartnerOrganizationApiKeyPermission = {}));
